import React, { Fragment, useState } from 'react'
import { Col, Grid, Row } from 'react-bootstrap'
import styled, { withTheme } from 'styled-components'
import { Link } from 'react-router'
import PropTypes from 'prop-types'

import { ExpressNavBar, Logo, OutsideAlerter } from '..'

import { ContactUsModalContainer } from '../../containers'
import '../../types'

const ContactUs = styled.p`
  color: var(--clr-grey-3-to-black) !important;
  text-transform: none !important;
  cursor: pointer;
  padding: 1px 24px 0px 0px;
  margin: 0px;

  :hover,
  :focus {
    text-decoration: underline !important;
  }
`

const TopLinks = styled.div`
  background: var(--clr-custom-to-accent);

  .container {
    display: flex;
    justify-content: flex-end;
  }

  span {
    margin: 0;
    padding: 0 15px;
    border: 0;
    vertical-align: 0;
  }

  .link-language a {
    color: var(--clr-grey-3-to-black);
    text-decoration: none;
    text-transform: uppercase;
  }
`

const TopNav = styled.div`
  min-height: 100%;
  background: var(--clr-custom-to-accent);
  padding: 10px 0;

  .row {
    display: table;
    width: 100%;

    .nav-col {
      display: table-cell;
      float: none;
      vertical-align: bottom;
    }
  }
`

/**
 * @typedef {Object} NavbarProps
 * @property {function({ category: string, data: object }): void} createUserEvent
 * @property {Device} [currentDevice]
 * @property {function(string): string} getOption
 * @property {LandingCategories} landingCategories
 * @property {Location} location
 * @property {Object} query
 * @property {Boolean} showHeader
 * @property {function(): void} toggleDeviceModal
 * @property {TopLinks} topLinks
 */

/**
 * Navbar
 * The default navigation component at Header
 *
 * @component
 * @param {NavbarProps}
 * @returns {React.ElementType}
 */
const Navbar = ({
  createUserEvent,
  currentDevice,
  getOption,
  landingCategories,
  location,
  query,
  showHeader,
  toggleDeviceModal,
  topLinks
}) => {
  const [showModal, setShowModal] = useState(false)
  const [expandExpressNav, setExpandExpressNav] = useState(false)

  const contactButton = getOption('header.contactButton')
  return (
    <Fragment>
      {(topLinks.show || contactButton) && (
        <TopLinks>
          <Grid>
            {topLinks.show && (
              <span className="link-language">
                <a href={topLinks.url}>{topLinks.text}</a>
              </span>
            )}
            {contactButton && (
              <Fragment>
                <ContactUs onClick={() => setShowModal(true)}>
                  {contactButton}
                </ContactUs>
                <ContactUsModalContainer
                  show={showModal}
                  onHide={() => setShowModal(false)}
                />
              </Fragment>
            )}
          </Grid>
        </TopLinks>
      )}
      {showHeader && (
        <TopNav>
          <Grid>
            <Row>
              <Col
                className="nav-col"
                xs={10}
                sm={getOption('header.logoMaxHeight') ? 4 : 3}
                md={getOption('header.logoMaxHeight') ? 3 : 2}
              >
                {getOption('header.logoLink') ? (
                  <a
                    href={getOption('header.logoLink')}
                    target={
                      getOption('header.logoLinkSelf')
                        ? '_self'
                        : '_blank rel="noopener noreferrer"'
                    }
                  >
                    <Logo
                      src={getOption('header.headerLogo')}
                      alt={getOption('pageTitle')}
                    />
                  </a>
                ) : (
                  <Link
                    to={{ pathname: '/', query }}
                    onClick={() =>
                      createUserEvent({
                        category: 'navigation',
                        data: { link_to: '/', source: 'HeaderHome' }
                      })
                    }
                  >
                    <Logo
                      src={getOption('header.headerLogo')}
                      alt={getOption('pageTitle')}
                    />
                  </Link>
                )}
              </Col>
              <Col
                className="nav-col"
                xsHidden
                sm={getOption('header.logoMaxHeight') ? 7 : 8}
                md={getOption('header.logoMaxHeight') ? 8 : 9}
              >
                {expandExpressNav ? (
                  <OutsideAlerter
                    outsideAction={() => setExpandExpressNav(!expandExpressNav)}
                  >
                    <ExpressNavBar
                      location={location}
                      expressCategories={landingCategories}
                      query={query}
                      expanded={expandExpressNav}
                      onExpand={() => setExpandExpressNav(!expandExpressNav)}
                      toggleDeviceModal={toggleDeviceModal}
                      currentDevice={currentDevice}
                    />
                  </OutsideAlerter>
                ) : (
                  <ExpressNavBar
                    location={location}
                    expressCategories={landingCategories}
                    query={query}
                    expanded={expandExpressNav}
                    onExpand={() => setExpandExpressNav(!expandExpressNav)}
                    toggleDeviceModal={toggleDeviceModal}
                    currentDevice={currentDevice}
                  />
                )}
              </Col>
            </Row>
          </Grid>
        </TopNav>
      )}
    </Fragment>
  )
}

Navbar.propTypes = {
  createUserEvent: PropTypes.func.isRequired,
  landingCategories: PropTypes.arrayOf(
    PropTypes.shape({
      accadLink: PropTypes.string,
      name: PropTypes.string,
      icon: PropTypes.string,
      children: PropTypes.arrayOf(
        PropTypes.shape({
          children: PropTypes.arrayOf(
            PropTypes.shape({
              academyCategoryFk: PropTypes.number,
              name: PropTypes.string,
              outputOrder: PropTypes.number,
              phoneFk: PropTypes.number,
              pk: PropTypes.number,
              presales: PropTypes.number,
              slug: PropTypes.string,
              val: PropTypes.string
            })
          ),
          name: PropTypes.string
        })
      )
    })
  ).isRequired,
  location: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  currentDevice: PropTypes.shape({
    customerID: PropTypes.string,
    id: PropTypes.number.isRequired,
    image_location: PropTypes.string.isRequired,
    manufacturer: PropTypes.string,
    name: PropTypes.string,
    name_pretty: PropTypes.string.isRequired,
    os: PropTypes.string,
    slug: PropTypes.string.isRequired,
    vanity_name: PropTypes.string
  }),
  toggleDeviceModal: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
  getOption: PropTypes.func.isRequired,
  topLinks: PropTypes.shape({
    show: PropTypes.bool,
    text: PropTypes.string,
    url: PropTypes.string.isRequired
  }).isRequired
}

export default withTheme(Navbar)



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js